import { MdsIcon } from "@/design-system/components/icon";
import styled from "@emotion/styled";

export const StyledPlanCardFeatures = styled.div`
  padding: 0 ${({ theme }) => theme.spacing["5"]} 0 ${({ theme }) => theme.spacing["5"]};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[4]};
  margin-top: ${({ theme }) => theme.spacing[3]};
  margin-bottom: ${({ theme }) => theme.spacing[3]};
`;

export const StyledFeatureRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["1"]};
`;

export const StyledFeatureIcon = styled(MdsIcon)<{ $color: string }>`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: ${({ $color }) => $color};
`;
